import { cx } from "@emotion/css";
import React from "react";

export const I: React.FC<{ className?: string; children: React.ReactNode }> = (
  props,
) => {
  return <span className={cx("i", props.className)}>{props.children}</span>;
};
